import type { Inline, LegalContent } from "./legal";

const t = (text: string): Inline => ({ t: "text", text });
const em = (): Inline => ({ t: "email", text: "info@quintaratech.com" });

export const defaultTermsContent: LegalContent = {
  meta: { title: "Quintara Terms of Use", description: "Terms that apply to use of the Quintara website." },
  hero: { eyebrow: "Legal", heading: "Website terms of use", dateLabel: "Last updated 2 October 2026" },
  body: [
    {
      kind: "p",
      spans: [t("These terms apply to your use of this website, operated by Quintara Advertising Services L.L.C, Commercial Licence No. 1648840, Dubai, United Arab Emirates. Use of the Quintara platform is governed by a separate client agreement.")],
    },
    { kind: "h2", text: "Information on this site" },
    {
      kind: "p",
      spans: [t("We describe our services and plans in good faith, but the content is general information and not an offer. Features, availability and service targets may vary by market and are confirmed in your client agreement.")],
    },
    { kind: "h2", text: "Intellectual property" },
    {
      kind: "p",
      spans: [t("The Quintara name, logo and site content belong to Quintara or its licensors. WhatsApp and Meta are trademarks of Meta Platforms, Inc., used here only to describe the platform our services run on. Quintara is not affiliated with or endorsed by Meta unless stated otherwise.")],
    },
    { kind: "h2", text: "Acceptable use" },
    {
      kind: "p",
      spans: [t("Do not attempt to disrupt the site, access it by automated means beyond normal indexing, or submit false information through our forms.")],
    },
    { kind: "h2", text: "Links" },
    {
      kind: "p",
      spans: [t("Links to other sites, including those of Numbase Group and JGroup, are provided for convenience. We are not responsible for their content.")],
    },
    { kind: "h2", text: "Liability" },
    { kind: "p", spans: [t("To the extent the law allows, we are not liable for losses arising from use of this website.")] },
    { kind: "h2", text: "Governing law" },
    {
      kind: "p",
      spans: [t("These terms are governed by the laws of the Emirate of Dubai and the federal laws of the United Arab Emirates, and the courts of Dubai have jurisdiction.")],
    },
    { kind: "h2", text: "Contact" },
    {
      kind: "p",
      spans: [t("Email "), em(), t(" or write to Quintara Advertising Services L.L.C,Dubai, United Arab Emirates.")],
    },
  ],
};
